// eslint-disable-next-line import/no-unresolved
import { useAppSelector } from "src/utils/hooks/useAppSelector";
// eslint-disable-next-line import/no-unresolved
import { onChangeIndianCurrency } from "src/helpers/FormDetails";
import CustomReviewField from "../../../../../shared/CustomReviewField";
import CustomLabel from "../../../../../shared/CustomLabel";

function OtherPolicyReview() {
  const loanDetails = useAppSelector((state) => state.loanDetails);
  const otherPolicyMefFields = useAppSelector(
    (state) => state.masterdata_reducer?.mefJourneySchema?.existingInsurance
  );
  return (
    <div>
      <div className="flex justify-between mt-8 mb-6">
        <div className="text-base font-bold">Other Policy Details</div>
      </div>
      <div>
        {loanDetails?.existingPolicy?.existingPolicyDetails?.map((existingPolicyDetails, index) => (
          <div>
            {index > 0 && <hr className="mt-6" />}
            <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 md:gap-x-28 gap-x-3 mt-6 max-sm:ml-4 ">
              {(existingPolicyDetails?.policyNumber ||
                otherPolicyMefFields?.policyNumber?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{otherPolicyMefFields?.policyNumber?.label}</CustomLabel>
                  <CustomReviewField>
                    {existingPolicyDetails?.policyNumber || "-"}
                  </CustomReviewField>
                </div>
              )}
              {(existingPolicyDetails?.totalSumInsured ||
                otherPolicyMefFields?.totalSumAssured?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{otherPolicyMefFields?.totalSumAssured?.label}</CustomLabel>
                  <CustomReviewField>
                    {onChangeIndianCurrency(existingPolicyDetails?.totalSumInsured || "-")}
                  </CustomReviewField>
                </div>
              )}
              {(existingPolicyDetails?.nameOfInsuranceCompany ||
                otherPolicyMefFields?.nameOfInsuranceCompany?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{otherPolicyMefFields?.nameOfInsuranceCompany?.label}</CustomLabel>
                  <CustomReviewField>
                    {existingPolicyDetails?.nameOfInsuranceCompany || "-"}
                  </CustomReviewField>
                </div>
              )}
              {(existingPolicyDetails?.acceptanceTerms ||
                otherPolicyMefFields?.acceptanceTerms?.visible) && (
                <div className="col-span-1">
                  <CustomLabel>{otherPolicyMefFields?.acceptanceTerms?.label}</CustomLabel>
                  <CustomReviewField>
                    {existingPolicyDetails?.acceptanceTerms || "-"}
                  </CustomReviewField>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
export default OtherPolicyReview;
